import authorization from './authorization.js';
import forbidden from './forbidden.js';
import notFound from './notFound.js';
import conflict from './conflict.js';
import unprocessableEntity from './unprocessableEntity.js';
export default {
    authorization,
    forbidden,
    notFound,
    conflict,
    unprocessableEntity,
};
//# sourceMappingURL=index.js.map